import { StorageBackend } from '@openid/appauth';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

export default class SecureStorageBackend extends StorageBackend {
  async getItem(name: string): Promise<string> {
    const result = await SecureStoragePlugin.get({ key: name });
    if (!result.value) throw new Error('Failed to get item');
    return result.value;
  }

  async removeItem(name: string): Promise<void> {
    try {
      await SecureStoragePlugin.get({ key: name });
      // The remove api does not throw an exception if the key does not exist, so we must rely on "get" to check if the key exists
      await SecureStoragePlugin.remove({ key: name });
    } catch (e) {
      console.warn('Failed to remove item', e);
    }
  }

  async clear(): Promise<void> {
    await SecureStoragePlugin.clear();
  }

  async setItem(name: string, value: string): Promise<void> {
    const result = await SecureStoragePlugin.set({ key: name, value });
    if (!result.value) throw new Error('Failed to set item');
  }
}
